import React from 'react'
import { motion } from 'framer-motion/dist/framer-motion'

import usePreloadImage from '../../../usePreloadImage'

const MemberAward = ({item}) => {
    const imageLoaded = usePreloadImage(item.image);
    return (
        <motion.li className="mga-memberawards__item">
            {item.url ?
                <a
                    className={`mga-memberawards__item__wrapper${!imageLoaded ? ' mga-img-loading' : ''}`}
                    href={item.url}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                >
                    <img src={item.image} alt={item.title} />
                </a> : 
                <div className={`mga-memberawards__item__wrapper${!imageLoaded ? ' mga-img-loading' : ''}`}>
                    <img src={item.image} alt={item.title} />
                </div>
            }
        </motion.li>
    )
}

export default MemberAward